export type Export = {
  id: number;
  file: string;
  status: string;
  isDeleted: number;
  createdAt: string;
  updatedAt: string;
  queryName?: string | null;
  labType?: string | null;
  viewMode?: string | null;
  columnCount?: number | null;
  historicDatabaseName?: string | null;
  filtersJson?: string | null;
};


